import { Typography } from '@guildeducationinc/recess';
import NotificationsIcon from '@guildeducationinc/recess/icons/NotificationsIcon';
import './Banner.scss';
import snakeCase from 'lodash/snakeCase';
import { useFeature } from '@optimizely/react-sdk';
import { clickable } from '@src/analytics';

const Banner = () => {
  const [isEnabled, variables] = useFeature('home_banner');
  const bannerMessage = variables?.BANNER_MESSAGE;
  const link = variables?.BANNER_LINK_URL;
  const linkText = variables?.BANNER_LINK_TEXT;

  if (!isEnabled || (isEnabled && !variables?.BANNER_MESSAGE)) {
    return null;
  }

  return (
    <div className='banner' data-testid='homeBanner'>
      <NotificationsIcon size={24} className='bannerIcon' />
      <Typography variant='body1' className='bannerMessage'>
        {bannerMessage}{' '}
        {link && linkText && (
          <a
            href={link}
            className='bannerURL'
            target='_blank'
            rel='noopener, noreferrer'
            onClick={() => {
              clickable({
                product: 'home',
                loggedIn: true,
                tag: 'home_banner',
                text: snakeCase(linkText),
                type: 'link',
              });
            }}
          >
            {linkText}
          </a>
        )}
      </Typography>
    </div>
  );
};

export default Banner;
